import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Arbeitsbereich';

export function AktuelleStation({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { currentStation, nextStation } = rotationsplan;

  if (currentStation) {
    return currentStation instanceof ArbeitsbereichStation ? (
      <Arbeitsbereich arbeitsbereichStation={currentStation} />
    ) : null;
  }

  if (nextStation) {
    return nextStation instanceof ArbeitsbereichStation ? (
      <Arbeitsbereich
        arbeitsbereichStation={nextStation}
        isNext
        isPlanGestartet={rotationsplan.status !== 'geplant'}
      />
    ) : null;
  }

  return null;
}
